import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  GROUPS_OF_MANAGERS_PERMISSIONS,
  GROUPS_OF_MANAGERS_ROUTE_NAME,
  TRANSLATION_GROUPS_OF_MANAGERS_LIST,
} from '@modules/groups-of-managers/constants';
import { getTranslationKeys } from '@modules/groups-of-managers/translations';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_PERSONNEL_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

export class GroupsOfManagersModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: GROUPS_OF_MANAGERS_ROUTE_NAME,
      path: 'groups-of-managers',
      permission: GROUPS_OF_MANAGERS_PERMISSIONS.SHOW,
      component: () => import('@modules/groups-of-managers/pages/GroupOfManagersPage/GroupOfManagersPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PERSONNEL_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PERSONNEL_GROUP_OF_MANAGERS'),
      to: {
        name: GROUPS_OF_MANAGERS_ROUTE_NAME,
      },
      permission: GROUPS_OF_MANAGERS_PERMISSIONS.SHOW,
      id: GROUPS_OF_MANAGERS_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_MANAGERS_LIST, getTranslationKeys);
  }
}
